import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";
const AboutMe = () => {
      const { t } = useTranslation();

  return (
    <div className="container mt-5" dir="rtl">
      {/* תמונות למעלה */}
      <div className="row text-center m-5 p-5 ratio-4x3">
       
        <div className="col-md-4 mb-3">
          <img
            src="/Fish-Pettice.jpeg"
            alt="img1"
            className="img-fluid rounded shadow"
          />
        </div>

        <div className="col-md-4 mb-3">
          <img
            src="/meatBall.jpeg"
            alt="img2"
            className="img-fluid rounded shadow"
          />
        </div>

        <div className="col-md-4 mb-3">
          <img
            src="/matbucha.jpeg"
            alt="img3"
            className="img-fluid rounded shadow"
          />
        </div>
      </div>

      <div className="text-center">
        <h2 className="fw-bold mb-3">{t("about_me")} </h2>
        <p className="lead fw-bold">
            {t("about_me_text")}
        </p>
      </div>
    </div>
  );
};

export default AboutMe;
